import React from 'react'
import { kebabCase } from 'lodash'
import { Link } from 'gatsby'
import { Tag } from '../types'
import { Button } from 'antd'

export const TagList: React.FC<{ group: Tag[]; prefix: string }> = ({
  group,
  prefix
}) => (
  <div className="tag-list">
    {group
      .sort((a, b) => b.totalCount - a.totalCount)
      .map(category => (
        <Button className="tag" key={category.fieldValue} size="large">
          <Link to={`/${prefix}/${kebabCase(category.fieldValue)}/`}>
            {category.fieldValue} ({category.totalCount})
          </Link>
        </Button>
      ))}
  </div>
)
